const MinusIcon = () => (
  <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="12" height="1" rx="0.5" fill="#F36E22" />
  </svg>
);

export default MinusIcon;
